import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  Grid,
  InputAdornment,
  makeStyles,
  Paper,
  TextField,
} from "@material-ui/core";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, Redirect, useHistory } from "react-router-dom";
import { compose } from "redux";
import LogoLight from "../../Components/LogoLight";
import actions from "../../Stores/Auth/actions";

const loginAction = actions.login;
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  inputSpacing: {
    marginBottom: "10px",
  },
}));

const Login = ({ login, isLoggingIn, error, isAuthenticated }) => {
  const classes = useStyles();
  const [show, setShow] = useState(0);
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const history = useHistory();
  const onChange = (e) =>
    setCredentials({ ...credentials, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    login(credentials, history);
  };

  return (
    <Container maxWidth="xs" style={{ paddingTop: "8rem" }}>
      {/* {isAuthenticated && <Redirect to="/d/review/listing" />} */}
      {isLoggingIn && (
        <Backdrop className={classes.backdrop} open>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Paper style={{ marginBottom: "20px" }}>
        <Box p="20px">
          <div
            style={{
              width: "60%",
              marginLeft: `-1.2rem`,
              marginTop: `-0.5rem`,
              marginBottom: "0.6rem",
            }}
          >
            <LogoLight />
          </div>
          <div>
            <form onSubmit={onSubmit}>
              <TextField
                name="email"
                label="Email"
                type="email"
                fullWidth
                autoFocus
                required
                value={credentials.email}
                onChange={onChange}
                className={classes.inputSpacing}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <PersonOutlineOutlinedIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                name="password"
                label="Password"
                // type="password"
                type={show ? "text" : "password"}
                fullWidth
                required
                value={credentials.password}
                onChange={onChange}
                className={classes.inputSpacing}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      {show ? (
                        <VisibilityIcon onClick={() => setShow(false)} />
                      ) : (
                        <VisibilityOffIcon onClick={() => setShow(true)} />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <Grid container alignItems="center" justify="space-between">
                <Grid item>
                  <FormControlLabel
                    control={<Checkbox color="primary" />}
                    label="Remember me"
                  />
                </Grid>
                <Grid item>
                  <Button
                    disableFocusRipple
                    disableRipple
                    style={{ textTransform: "none" }}
                    variant="text"
                    color="primary"
                    type="button"
                  >
                    <Link to="/forgot/password">Forgot password?</Link>
                  </Button>
                </Grid>
              </Grid>
              {/* {error != null && error.message ? (
                <Grid container justify="flex-start">
                  <Alert severity="error">{error.message}!</Alert>
                </Grid>
              ) : (
                ''
              )} */}
              <Grid container justify="flex-end" style={{ marginTop: "10px" }}>
                <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={{ textTransform: "none" }}
                >
                  Login
                </Button>
              </Grid>
            </form>
            {/* Don't have an account?<Link to="/admin/register"> Sign Up</Link> */}
          </div>
        </Box>
      </Paper>
    </Container>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isLoggingIn: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = ({ AuthReducer }) => ({
  isAuthenticated: AuthReducer.isAuthenticated,
  isLoggingIn: AuthReducer.isLoggingIn,
  error: AuthReducer.error,
});
function mapDispatchToProps(dispatch) {
  return {
    login: (...args) => dispatch(loginAction(...args)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Login);
